import { useQuery } from "react-query";
import API from "../../Config/axios";
import { QUERY_KEY } from "../../Constants/query-keys";

const onGetQueueAllConfigurations = async () => {
  const { data } = await API.get("/queue_configurations");
  return data;
};

const useGetQueueAllConfigurations = () => {
  return useQuery(
    [QUERY_KEY.GET_QUEUE_ALL_CONFIGURATION],
    onGetQueueAllConfigurations,
    {
      refetchOnMount: true,
      refetchOnWindowFocus: false,
    }
  );
};

export default useGetQueueAllConfigurations;
